import { authAtom } from "@src/atoms";
import { useAtom } from "jotai";
import { lazy, Suspense, type ReactNode } from "react";

const ConversationSocketProvider = lazy(() =>
  import("@src/pages/Massages/Context").then((m) => ({
    default: m.ConversationSocketProvider,
  })),
);

/**
 * Loads socket.io + messaging context only after auth,
 * so public routes (sign-in / sign-up) stay out of that chunk.
 */
export function AuthGatedConversationSocket({
  children,
}: {
  children: ReactNode;
}) {
  const [auth] = useAtom(authAtom);

  if (auth.isAuthenticated !== true) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<>{children}</>}>
      <ConversationSocketProvider>{children}</ConversationSocketProvider>
    </Suspense>
  );
}
